export const EVENT_BUS_USER_LAST_VISIT_NOTIFICATIONS    = 'change:lastVisitNotifications'
export const EVENT_BUS_USER_LAST_VISIT_MY_WORK          = 'change:lastVisitMyWork'